import { Component, EventEmitter, Input, Output } from '@angular/core';

/** Un paso del riel. `estado`: HECHO (con visto), ACTUAL (el que manda), PENDIENTE o FALLO (rechazada). */
export interface PasoRiel { clave: string; nombre: string; detalle?: string | null; estado: 'HECHO' | 'ACTUAL' | 'PENDIENTE' | 'FALLO'; }

/**
 * El riel de pasos de la casa — uno solo para el workflow de la solicitud, «Completar mi parte», la
 * nueva solicitud y las condiciones (CONTRATO-REDISENO-ALTAS.md). shadcn no trae stepper: se compone
 * con sus tokens, como el Progress tracker de Atlassian (etiquetas de una o dos palabras, estados
 * hecho / actual / pendiente). Horizontal; en pantallas angostas se envuelve.
 */
@Component({
  selector: 'app-riel-pasos',
  templateUrl: './riel-pasos.component.html',
  styleUrls: ['./riel-pasos.component.css'],
})
export class RielPasosComponent {
  @Input() pasos: PasoRiel[] = [];
  /** Si se puede tocar un paso para ir a él (en un formulario por pasos, sí; en el workflow, no). */
  @Input() navegable = false;
  @Input() rotulo = 'Pasos';
  @Output() elegir = new EventEmitter<string>();

  tocar(p: PasoRiel): void { if (this.navegable && p.estado !== 'PENDIENTE') this.elegir.emit(p.clave); }
}
